export function urlWithQuery(url: URL, params: { [x: string]: string | null }) {
    const copy = new URL(url);
    for (const paramName in params) {
        if (params[paramName] === null) {
            copy.searchParams.delete(paramName);
        } else {
            copy.searchParams.set(paramName, params[paramName] || "");
        }
    }

    return copy;
}

export function overrideQuery(override: { [x: string]: string | null }) {
    return urlWithQuery(new URL(window.location.href), override);
}
